import NumberInput from "../../../components/NumberInput";
import { useState } from "react";

import { formatIDR } from "../../../utils/helpers/formatIDR";
import UserAvatar from "../../../components/UserAvatar";
import {
  calculateBaseQuantity,
  calculateIngredientCost,
  getBaseUnitLabel,
  getPriceUnitLabel,
} from "../../../utils/helpers/pricing";
import { toUnitOptions } from "../../../utils/helpers/unitOptions";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../components/FormValidation";

const FormProduction = (props) => {
  const { isShowModal: _isShowModal, isEdit, closeModal, formState, setFormState, addProduction, units, canProcess = false } = props;

  const [searchTerm, setSearchTerm] = useState("");
  const [validationAttempted, setValidationAttempted] = useState(false);
  const optionUnit = toUnitOptions(units);
  const productionQty = Math.max(0, Number(formState?.qty_production || 0));
  const isStockExceeded = formState?.materials?.some((material) => {
    const requiredQuantity = productionQty * calculateBaseQuantity(material, optionUnit);

    return requiredQuantity > Number(material?.stock || 0);
  });

  // Hitung total biaya bahan baku
  const calculateTotalCost = () => {
    let total = 0;
    formState?.materials?.forEach((material) => {
      total += calculateIngredientCost(material, optionUnit) * productionQty;
    });
    return total;
  };

  const handleSave = async () => {
    setValidationAttempted(true);
    if (!canProcess || !Number.isInteger(productionQty) || productionQty <= 0 || isStockExceeded || !formState?.materials?.length) return;
    const productionData = {
      product_id: formState?.id,
      qty: formState?.qty_production,
    };
    const success = await addProduction(productionData);
    if (success) document.querySelector("#modal-form-production .btn-close")?.click();
  };

  return (
    <div
      className="modal modal-blur fade"
      id="modal-form-production"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(4px)",
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-building-factory-2 me-2">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 21h18" />
                <path d="M5 21v-12l5 4v-4l5 4h4" />
                <path d="M19 21v-8l-1.436 -9.574a.5 .5 0 0 0 -.495 -.426h-1.145a.5 .5 0 0 0 -.494 .418l-1.43 8.582" />
                <path d="M9 17h1" />
                <path d="M14 17h1" />
              </svg>
              Produksi {formState?.name}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Tutup"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice
              errors={validationAttempted ? {
                ...(!Number.isInteger(productionQty) || productionQty <= 0 ? { qty: "Jumlah produksi harus bilangan bulat lebih dari 0." } : {}),
                ...(!formState?.materials?.length ? { materials: "Resep produk belum memiliki bahan baku." } : {}),
                ...(isStockExceeded ? { stock: "Stok bahan baku tidak mencukupi." } : {}),
              } : {}}
              title="Produksi belum dapat diproses."
            />
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <div className="card bg-light border-0 h-100">
                  <div className="card-body py-3">
                    <div className="text-secondary small fw-bold text-uppercase">Produk</div>
                    <div className="h3 mb-1">{formState?.name || "-"}</div>
                    <div className="text-secondary">
                      Stok saat ini: <strong>{Number(formState?.stock || 0)} {formState?.unit || "pcs"}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card bg-primary-lt border-0 h-100">
                  <div className="card-body py-3">
                    <div className="text-secondary small fw-bold text-uppercase">Harga Produk</div>
                    <div className="h2 mb-1 text-primary">{formatIDR(formState?.unit_price || 0)}</div>
                    <div className="text-secondary">Harga jual per {formState?.unit || "produk"}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div
                  className="card mb-3"
                  style={
                    {
                      // display: selectedMaterials.length === 0 ? "none" : "block",
                    }
                  }>
                  <div className="card-header">
                    <h3 className="card-title">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="me-2 text-success">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      Jumlah Produksi {formState?.qty_production} {formState?.unit}
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row g-3">
                      <div className="col-12">
                        <div className="card card-sm">
                          <div className="card-body">
                            <div className="d-flex">
                              <button
                                className="btn btn-sm btn-link text-danger "
                                onClick={() => {
                                  if (formState?.qty_production - 1 > 0) {
                                    setFormState((prev) => ({
                                      ...prev,
                                    qty_production: Number(prev.qty_production || 0) - 1,
                                    }));
                                  }
                                }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-minus">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M5 12l14 0" />
                                </svg>
                              </button>

                              <div className="flex-grow-1 w-100 m-auto">
                                <label className="visually-hidden">Jumlah produksi<RequiredMark /></label>
                                <NumberInput
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  className={`form-control text-center h1 fw-bold m-0${validationAttempted && (!Number.isInteger(productionQty) || productionQty <= 0) ? " is-invalid" : ""}`}
                                  min="1"
                                  step="1"
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    boxShadow: "none",
                                  }}
                                  value={formState?.qty_production}
                                  onChange={(e) => {
                                    setFormState((prev) => ({
                                      ...prev,
                                      qty_production: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                              <button
                                className="btn btn-sm btn-link text-success"
                                onClick={() => {
                                  setFormState((prev) => ({
                                    ...prev,
                                    qty_production: Number(prev.qty_production || 0) + 1,
                                  }));
                                }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-plus">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M12 5l0 14" />
                                  <path d="M5 12l14 0" />
                                </svg>
                              </button>
                            </div>
                            <FieldFeedback formId="production" name="qty" error={validationAttempted && (!Number.isInteger(productionQty) || productionQty <= 0) ? "Jumlah produksi harus bilangan bulat lebih dari 0." : ""} hint="Jumlah produk jadi yang akan ditambahkan ke stok." />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="alert alert-info mt-3 mb-0">
                      <div className="d-flex align-items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="me-2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="16" x2="12" y2="12"></line>
                          <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                        <div>
                          <strong>Total HPP Produksi: {formatIDR(calculateTotalCost())}</strong>
                          <br />
                          {/* <small>Dari {selectedMaterials.length} bahan baku yang digunakan</small> */}
                        </div>
                      </div>
                    </div>
                    {isStockExceeded && (
                      <div className="alert alert-danger mt-3 mb-0">
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="me-2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                          </svg>
                          <div>
                            {/* <strong>Stok Bahan Baku Tidak Cukup</strong> */}
                            {/* <br /> */}
                            <small>Stok bahan baku tidak mencukupi untuk produksi</small>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Daftar Bahan Baku - Tabler Table Style */}
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Daftar Bahan Baku</h3>
                    <div className="card-actions">
                      <span className="badge bg-primary text-primary-fg">
                        {formState?.materials?.length || 0} Bahan
                      </span>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-vcenter card-table">
                        <thead>
                          <tr>
                            <th className="w-1">no</th>
                            <th>Bahan Baku</th>
                            <th className="text-start">Kebutuhan</th>
                            <th className="text-start">Stok Awal</th>
                            <th className="text-start">Sisa Stok</th>
                            <th className="text-start">Harga Satuan</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formState?.materials?.length > 0 ? (
                            formState?.materials?.map((material, index) => {
                              const materialName = material?.name || material?.material_name || `Bahan baku #${index + 1}`;
                              const requiredQty = productionQty * calculateBaseQuantity(material, optionUnit);
                              const initialStock = Number(material?.stock || 0);
                              const remainingStock = initialStock - requiredQty;
                              const isInsufficient = remainingStock < 0;
                              const stockUnitLabel = getBaseUnitLabel(optionUnit, material?.unit);
                              const priceUnitLabel = getPriceUnitLabel(optionUnit, material?.unit);

                              return (
                                <tr
                                  key={material?.material_id || material?.id || index}
                                  className={isInsufficient ? "table-danger" : ""}>
                                  <td>{index + 1}.</td>
                                  <td data-label="Nama">
                                    <div className="d-flex py-1 align-items-center">
                                      <UserAvatar
                                        fullName={materialName}
                                        imageUrl={material?.image_path || material?.image}
                                        image_path={material?.image_path || material?.image}
                                        size="md"
                                        className="me-2"
                                        justPhotoView={false}
                                      />

                                      <div className="flex-fill">
                                        <div className="font-weight-medium fw-bold">{materialName}</div>
                                        <div className="text-secondary text-capitalize">
                                          <span className="text-reset ">{material?.type}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center fw-bold">
                                    {requiredQty.toLocaleString("id-ID", { maximumFractionDigits: 2 })} {stockUnitLabel}
                                  </td>
                                  <td className="text-start fw-semibold text-secondary">
                                    {initialStock.toLocaleString("id-ID", { maximumFractionDigits: 2 })} {stockUnitLabel}
                                  </td>
                                  <td className={`text-start fw-bold ${isInsufficient ? "text-danger" : "text-success"}`}>
                                    {remainingStock.toLocaleString("id-ID", { maximumFractionDigits: 2 })} {stockUnitLabel}
                                    <div className="small fw-normal text-secondary">
                                      berkurang {requiredQty.toLocaleString("id-ID", { maximumFractionDigits: 2 })} {stockUnitLabel}
                                    </div>
                                  </td>
                                  <td className="text-center fw-bold">
                                    {formatIDR(material.unit_cost || 0)}
                                    <div className="form-hint">per {priceUnitLabel}</div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center py-5">
                                <div className="empty">
                                  <div className="empty-img">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="48"
                                      height="48"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1"
                                      strokeLinecap="round"
                                      strokeLinejoin="round">
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line x1="12" y1="8" x2="12" y2="12"></line>
                                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                    </svg>
                                  </div>
                                  {searchTerm ? (
                                    <>
                                      <p className="empty-title">Tidak ditemukan</p>
                                      <p className="empty-subtitle text-muted">
                                        Bahan baku "{searchTerm}" tidak tersedia
                                      </p>
                                      <button className="btn btn-link" onClick={() => setSearchTerm("")}>
                                        Hapus filter
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <p className="empty-title mb-1">Tidak ada data</p>
                                      <p className="empty-subtitle text-muted ">
                                        Pilih bahan baku/buat resep untuk produksi
                                      </p>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary" onClick={closeModal} data-bs-dismiss="modal">
              Batal
            </button>
            {isEdit ? (
              <button
                type="button"
                className="btn btn-primary"
                disabled={!canProcess}
                onClick={handleSave}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-plus">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                Produksi {formState?.qty_production} {formState?.unit}
              </button>
            ) : (
              <button type="button" className="btn btn-primary" disabled={!canProcess} onClick={handleSave}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="me-1">
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                Produksi
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormProduction;
